// Configuration constants
export const CONFIG_KEYS = [
  'BE_ENDPOINT_NON_ZI',
  'BE_ENDPOINT_ZI',
  'ZI_COOKIE',
  'REACT_APP_DOZI_URL',
  'DOZI_INBOX_URL',
  'REACT_APP_SENTRY_DSN',
  'REACT_APP_STRIPE_KEY',
  'REACT_APP_REDIRECT_URI_SALESFORCE',
  'REACT_APP_REDIRECT_URI_HUBSPOT',
  'REACT_APP_PUSHER_TOKEN',
  'REACT_APP_PUSHER_CLUSTER',
  'REACT_APP_CLIENT_ID_SALESFORCE',
  'REACT_APP_CLIENT_ID_HUBSPOT',
  'REACT_APP_MIXPANEL_TOKEN',
  'NODE_ENV',
  'REACT_APP_SLACK_CLIENT_ID',
  'REACT_APP_SLACK_OAUTH_URL',
  'REACT_APP_ZENDESK_CLIENT_ID',
  'REACT_APP_ZENDESK_OAUTH_URL',
  'REACT_APP_TEAMS_CLIENT_ID',
  'REACT_APP_TEAMS_OAUTH_URL',
  'REACT_APP_REDIRECT_URI_TEAMS',
  'REACT_APP_TEAMS_VALIDURLS',
  'REACT_APP_ZENDESK_VALIDURLS',
  'REACT_APP_SUPPORT_PROJECT_KEY',
  'REACT_APP_SUPPORT_PROJECT_ID',
  'REACT_APP_GOOGLE_CALENDAR_CLIENT_ID',
  'REACT_APP_GOOGLE_CALENDAR_OAUTH_URL',
  'REACT_APP_MICROSOFT_CALENDAR_CLIENT_ID',
  'REACT_APP_MICROSOFT_CALENDAR_OAUTH_URL',
  'REACT_APP_CS_DASHBOARD_VALID_URLS',
  'REACT_APP_ELOQUA_CLIENT_ID',
  'REACT_APP_ELOQUA_OAUTH_URL',
  'REACT_APP_ZOHO_OAUTH_URL',
  'REACT_APP_ZOHO_CLIENT_ID',
  'REACT_APP_HIDE_INTENT_RULE',
  'REACT_APP_TRANSLOADIT_AUTH_KEY',
  'REACT_APP_TRANSLOADIT_TEMPLATE_ID',
  'REACT_APP_AMPLITUDE_API_KEY',
  'REACT_APP_DASHBOARD_IDS',
  'REACT_APP_SISENSE_URL',
  'REACT_APP_SISENSE_AUTH_URL',
  'REACT_APP_TRANSLOADIT_ACCOUNT_TEMPLATE_ID',
  'REACT_APP_GIPHY_KEY',
  'REACT_APP_ZI_SCRIPTS_URL',
  'REACT_APP_INTERNAL_ANALYTICS_NAV',
];

// Special config keys that need custom handling
export const SPECIAL_CONFIG_KEYS = {
  REACT_APP_CS_DASHBOARD_VALID_URLS: 'REACT_APP_INTEGRATIONS_ANALYTICS_NAV',
  REACT_APP_HIDE_INTENT_RULE: 'REACT_APP_HIDE_INTENT',
};
